// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Components
import { BaseComponent } from './views/theme/base/base.component';
import { ErrorPageComponent } from './views/theme/content/error-page/error-page.component';
// Auth
import { AuthGuard } from './core/auth/_guards/auth.guard';
import { TranslateModule } from '@ngx-translate/core';
import { AuthComponent } from './views/pages/auth/auth.component';
import { AuthCallbackComponent } from './views/pages/auth/auth-callback/auth-callback.component';
import { LogoutCallbackComponent } from './views/pages/auth/logout-callback/logout-callback.component';
import { LoginComponent } from './views/pages/auth/login/login.component';

const routes: Routes = [
	{
		path: 'auth',
		component: AuthComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full'
			},
			{
				path: 'login',
				component: LoginComponent,
				data: {returnUrl: window.location.pathname}
			}
		]
	},
	{
		path: 'auth-callback',
		component: AuthCallbackComponent
	},
	{
		path: 'logout-callback',
		component: LogoutCallbackComponent
	},
	{
		path: 'disclaimer',
		canActivate: [AuthGuard],
		loadChildren: () => import('./views/pages/disclaimer/disclaimer.module').then(m => m.DisclaimerModule),
	},
	{
		path: 'unauthorized',
		component: ErrorPageComponent,
		data: {
			'type': 'error-v6',
			'code': 403,
			'title': 'AUTH.ERROR.UNAUTHORIZED_TITLE',
			'desc': 'AUTH.ERROR.UNAUTHORIZED_DESC'
		}
	},
	{
		path: '',
		component: BaseComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: 'welcome',	
				loadChildren: () => import('./views/pages/redirector/redirector.module').then(m => m.RedirectorModule)
			},
			{
				path: 'dashboard',	
				loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
			},	
			{
				path: 'thirdparties',	
				loadChildren: () => import('./views/pages/thirdparties/thirdparties.module').then(m => m.ThirdpartiesModule)
			},
			{
				path: 'import-thirdparty',	
				loadChildren: () => import('./views/pages/import-thirdparty/import-thirdparty.module').then(m => m.ImportThirdPartyModule)
			},
			{
				path: 'evaluations',	
				loadChildren: () => import('./views/pages/evaluations/evaluations.module').then(m => m.EvaluationsModule)
			},
			{
				path: 'questionnaires',	
				loadChildren: () => import('./views/pages/questionnaires/questionnaires.module').then(m => m.QuestionnairesModule)
			},
			{
				path: 'due-diligence',	
				loadChildren: () => import('./views/pages/due-diligence/due-diligence.module').then(m => m.DueDiligenceModule)
			},		
			{
				path: 'tracing',	
				loadChildren: () => import('./views/pages/tracing/tracing.module').then(m => m.TracingModule)
			},
			{
				path: 'reports',
				loadChildren: () => import('./views/pages/evaluation-reports/evaluation-report.module').then(m => m.EvaluationReportModule),
			},
			{
				path: 'survey',
				loadChildren: () => import('./views/pages/survey/survey.module').then(m => m.SurveyModule),
			},
			{
				path: 'thirdparty-tracing-tasks',	
				loadChildren: () => import('./views/pages/thirdparty-tracing-tasks/thirdparty-tracing-tasks.module').then(m => m.ThirdPartyTracingTasksModule)
			},
			{
				path: 'launches',
				loadChildren: () => import('./views/pages/launches/launches.module').then(m => m.LaunchesModule),
			},
			{
				path: 'survey-warnings',
				loadChildren: () => import('./views/pages/survey-warnings/survey-warnings.module').then(m => m.SurveyWarningsModule),
			},
			{
                path: 'unauthorized-inside',    
                loadChildren: () => import('./views/pages/unauthorized-inside/unauthorized-inside.module').then(m => m.UnauthorizedInsideModule)
            },
			{path: 'error/:type', component: ErrorPageComponent},
			{path: '', redirectTo: 'welcome', pathMatch: 'full'},
			{path: '**', redirectTo: 'welcome', pathMatch: 'full'}
		]
	},
	{path: '**', redirectTo: 'error/403', pathMatch: 'full'},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes),
		TranslateModule.forChild(),
		// AuthCallbackModule,
		// LogoutCallbackModule,
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
